import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";

import { i18n } from "../../main";

Vue.prototype.$loja_consumidor = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      dialogOrders: false,
      dialogItens: false,
      dialogExport: false,
      consumidores: [],
      select_consumidores: [],
      pedidos: [],
      loading_pedidos: false,
      itens_pedido: [],
      loading_itens_pedido: false,
      modalSelectStore: false,
      filtros: [],
      filter: {
        nome: "",
        razao_social: "",
        documento: "",
        passaporte: "",
        cnpj: "",
        status: "",
        tipoPessoa: "",
        dataInicio: "",
        dataFim: "",
        permite_pacote: false,
        sequenciador: null,
        event: "",
      },
      consumidorAddOrEdit: "new",
      loja_selecionada: "",
      lojas_loading: false,
      loja_cons: "",
      cadastro: {
        loading: false,
        loading_consumidores: false,
        dados_cadastrais: {
          id: "",
          pessoa: "FISICA",
          foto: { imagem: null, have: false },
          nome: "",
          dt_nascimento: "",
          documento: "",
          passaporte: "",
          email: "",
          celular: "",
          idioma: "",
          status: "",
          cep: "",
          pais: "",
          estado: "",
          cidade: "",
          bairro: "",
          logradouro: "",
          end_numero: "",
          cnpj: "",
          razao_social: "",
          permite_pacote: false,
          error: {
            nome: [],
            dt_nascimento: [],
            documento: [],
            passaporte: [],
            email: [],
            cnpj: [],
            razao_social: [],
            celular: [],
            idioma: [],
            status: [],
            cep: [],
            pais: [],
            estado: [],
            cidade: [],
            bairro: [],
            logradouro: [],
            end_numero: [],
          },
        },
      },
    };
  },
  methods: {
    getLojaID() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return this.$axios.getLocal("loja_consumidor_selecionada").data;
      else return this.$axios.getLocal("oe_user_info")?.data?.loja;
    },
    // ---- LISTAR CONSUMIDORES ---- //
    getConsumidor(loja) {
      this.cadastro.loading_consumidores = true;
      if (loja === "") {
        return;
      }
      this.$axios
        .post(this.ENDPOINTS.LISTAR_CONSUMIDOR, { loja: loja })
        .then(response => {
          let allConsumers = response.map(item => ({
            ...item,
            nome:
              item.razao_social && item.razao_social.length > 0
                ? item.razao_social
                : item.nome,
          }));
          this.consumidores = allConsumers;
          this.cadastro.loading = false;
          this.lojas_loading = false;
          this.cadastro.loading_consumidores = false;
        });
    },

    // ---- DESABILITAR CONSUMIDOR ---- //
    desabilitarConsumidor(idconsumidor) {
      this.$axios
        .put(this.ENDPOINTS.DESABILITAR_CONSUMIDOR + idconsumidor, {
          loja: this.getLojaID(),
        })
        .then(() => {
          this.getConsumidor(this.getLojaID());
        });
    },
    // ---- HABILITAR CONSUMIDOR ---- //
    habilitarConsumidor(idconsumidor) {
      this.$axios
        .put(this.ENDPOINTS.ALTERAR_CONSUMIDOR + idconsumidor, {
          loja: this.getLojaID(),
          status: "ATIVO",
        })
        .then(() => {
          this.getConsumidor(this.getLojaID());
        });
    },

    // ---- ALTERAR CONSUMIDOR ---- //
    alterarConsumidor() {
      this.cadastro.loading = true;
      let dados = {};
      if (this.cadastro.dados_cadastrais.pessoa == "JURIDICA") {
        dados = {
          loja: this.getLojaID(),
          email: this.cadastro.dados_cadastrais.email,
          permite_pacote: this.cadastro.dados_cadastrais.permite_pacote,
          senha: "",
          status: this.cadastro.dados_cadastrais.status,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          celular: this.cadastro.dados_cadastrais.celular,
          idioma: this.cadastro.dados_cadastrais.idioma,
          imagem: this.cadastro.dados_cadastrais.foto.imagem,
          isadmin: true,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_numero: this.cadastro.dados_cadastrais.end_numero,

          cnpj: this.cadastro.dados_cadastrais.cnpj,
          passaporte: this.cadastro.dados_cadastrais.passaporte,
          razao_social: this.cadastro.dados_cadastrais.razao_social,
        };
      } else {
        dados = {
          loja: this.getLojaID(),
          nome: this.cadastro.dados_cadastrais.nome,
          dt_nascimento: this.$config.convertDataEN(
            this.cadastro.dados_cadastrais.dt_nascimento
          ),
          email: this.cadastro.dados_cadastrais.email,
          permite_pacote: this.cadastro.dados_cadastrais.permite_pacote,
          senha: "",
          status: this.cadastro.dados_cadastrais.status,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          documento: this.cadastro.dados_cadastrais.documento,
          passaporte: this.cadastro.dados_cadastrais.passaporte,
          celular: this.cadastro.dados_cadastrais.celular,
          idioma: this.cadastro.dados_cadastrais.idioma,
          imagem: this.cadastro.dados_cadastrais.foto.imagem,
          isadmin: true,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_numero: this.cadastro.dados_cadastrais.end_numero,
        };
      }

      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_CONSUMIDOR + this.cadastro.dados_cadastrais.id,
          dados
        )
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditConsumidor", true);
            this.limpaFormularioDeConsumidor();
            router.push({
              name: "consumers",
            });
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- CADASTRAR CONSUMIDOR ---- //
    async cadastrarConsumidor() {
      this.cadastro.loading = true;
      let dados = {};
      if (this.cadastro.dados_cadastrais.pessoa == "JURIDICA") {
        dados = {
          loja: this.getLojaID(),

          email: this.cadastro.dados_cadastrais.email,
          senha: "",
          permite_pacote: this.cadastro.dados_cadastrais.permite_pacote,
          status: this.cadastro.dados_cadastrais.status,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          celular: this.cadastro.dados_cadastrais.celular,
          idioma: this.cadastro.dados_cadastrais.idioma,
          imagem: this.cadastro.dados_cadastrais.foto.imagem,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_numero: this.cadastro.dados_cadastrais.end_numero,

          cnpj: this.cadastro.dados_cadastrais.cnpj,
          passaporte: this.cadastro.dados_cadastrais.passaporte,
          razao_social: this.cadastro.dados_cadastrais.razao_social,
          captcha: "",
          isadmin: true,
        };
      } else {
        dados = {
          loja: this.getLojaID(),
          // dados cadastrais
          nome: this.cadastro.dados_cadastrais.nome,
          dt_nascimento: this.$config.convertDataEN(
            this.cadastro.dados_cadastrais.dt_nascimento
          ),
          email: this.cadastro.dados_cadastrais.email,
          permite_pacote: this.cadastro.dados_cadastrais.permite_pacote,
          senha: "",
          status: this.cadastro.dados_cadastrais.status,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          documento: this.cadastro.dados_cadastrais.documento,
          passaporte: this.cadastro.dados_cadastrais.passaporte,
          celular: this.cadastro.dados_cadastrais.celular,
          idioma: this.cadastro.dados_cadastrais.idioma,
          imagem: this.cadastro.dados_cadastrais.foto.imagem,

          // endereço
          end_cep: this.cadastro.dados_cadastrais.cep,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_numero: this.cadastro.dados_cadastrais.end_numero,
          captcha: "",
          isadmin: true,
        };
      }

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_CONSUMIDOR, dados)
        .then(response => {
          if (response) {
            this.limpaFormularioDeConsumidor();
            router.push({
              name: "consumers",
            });
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- FUNÇÃO PARA REDEFINIR A SENHA ---- //
    async trocarSenha() {
      let idusuario = this.$axios.getLocal("oe_user_info").data.idusuario;
      if (this.user.old_password.length == 0) {
        this.$config.alert(
          "Insira sua senha atual!",
          this.$config.dados.errorColor
        );
        this.$usuario.user.error.old_password = "Insira sua senha atual";
        return;
      }
      // if(this.validaSenha(this.cadastro.senha) < 60)
      //     { this.$config.alert(this.$t_('preencha_senha_corret'), this.$config.dados.errorColor); this.$usuario.cadastro.error.senha = this.$t_('preencha_senha_corret'); return }
      if (this.user.senha != this.user.senha2) {
        this.$config.alert(
          "As senhas são incompatíveis!",
          this.$config.dados.errorColor
        );
        this.$usuario.user.error.senha2 = "As senhas são incompatíveis!";
        return;
      }
      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_SENHA_CONSUMIDOR + idusuario,
          JSON.stringify({
            senha_antiga: this.user.old_password,
            senha_nova: this.user.senha,
          })
        )
        .then(response => {
          if (response) {
            localStorage.removeItem("token");
            this.$axios.destroy(true);
            this.user.old_password = "";
            this.user.show_old_pass = "password";
            this.user.senha = "";
            this.user.show_senha = "password";
            this.user.senha2 = "";
            this.user.show_senha2 = "password";
            if (location.pathname != "login") {
              setTimeout(() => {
                router.push("/");
              }, 3000);
            }
          }
        });
    },

    // ---- FUNÇÃO PARA OBTER TOKEN DO CONSUMIDOR ---- //
    async getToken(email) {
      return await this.$axios
        .get(this.ENDPOINTS.OBTER_TOKEN_USUARIO + `?email=${email}`)
        .then(response => {
          if (response) {
            return response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    filtroConsumidores() {
      this.filtros = [];

      function formatDate(date) {
        const dateParts = date.split("/");
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        return formattedDate;
      }

      if (this.filter.nome !== "") {
        this.filtros.push({
          campo: "con.nome",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.nome,
        });
      }

      if (this.filter.razao_social !== "") {
        this.filtros.push({
          campo: "con.razao_social",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.razao_social,
        });
      }

      if (this.filter.documento !== "") {
        this.filtros.push({
          campo: "con.documento",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.documento,
        });
      }

      if (this.filter.cnpj !== "") {
        this.filtros.push({
          campo: "cnpj",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.cnpj,
        });
      }

      if (this.filter.passaporte !== "") {
        this.filtros.push({
          campo: "con.passaporte",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.passaporte,
        });
      }

      if (this.filter.status != "" && this.filter.status != null) {
        this.filtros.push({
          campo: "con.status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      if (this.filter.dataInicio != "") {
        this.filtros.push({
          campo: "con.ins_dthr",
          tipo: "date",
          orientacao: "maior",
          valor: formatDate(this.filter.dataInicio) + " 00:00",
        });
      }

      if (this.filter.dataFim != "") {
        this.filtros.push({
          campo: "con.ins_dthr",
          tipo: "date",
          orientacao: "menor",
          valor: formatDate(this.filter.dataFim) + " 23:59",
        });
      }

      if (this.filter.tipoPessoa != "" && this.filter.tipoPessoa != null) {
        this.filtros.push({
          campo: "con.tipo_pessoa",
          tipo: "string",
          valor: this.filter.tipoPessoa,
        });
      }

      if (this.filter.email != "" && this.filter.email != null) {
        this.filtros.push({
          campo: "con.email",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.email,
        });
      }

      let loja;

      if (this.$axios.getLocal("oe_user_info").data.user_type == "loja") {
        loja = this.$axios.getLocal("oe_user_info").data.loja;
      } else {
        loja = this.$axios.getLocal("loja_consumidor_selecionada").data;
      }

      if (this.filter.permite_pacote !== false) {
        this.filtros.push({
          campo: "con.permite_pacote",
          tipo: "int",
          valor: 1,
        });
      }

      if (this.filter.estado) {
        this.filtros.push({
          campo: "con.end_estado",
          tipo: "string",
          valor: this.filter.estado,
        });
      }

      if (this.filter.cidade) {
        this.filtros.push({
          campo: "con.end_cidade",
          tipo: "string",
          valor: this.filter.cidade,
        });
      }

      let filtered = this.filtros;
      this.cadastro.loading_consumidores = true;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_CONSUMIDOR,
          JSON.stringify({
            loja: this.filter.sequenciador || loja,
            filtros: filtered,
            evento: this.filter.event,
          })
        )
        .then(response => {
          this.cadastro.loading_consumidores = false;
          this.consumidores = response;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    imprimirIngresso(iditem, item_name, sequenciador) {
      let dados = {
        loja: sequenciador,
        idioma: "pt",
        iditem: iditem,
        is_download: true,
      };

      this.$axios
        .postPDF(this.ENDPOINTS.IMPRIMIR_INGRESSO, dados)
        .then(response => {
          var file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    // ---- FUNÇÃO QUE VALIDA O CADASTRO ---- //
    async validarCadastro() {
      if (this.cadastro.dados_cadastrais.pais === "") {
        this.$config.alert(
          i18n.t("customers.country-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.pais = i18n.t(
          "customers.country-error"
        );
        return;
      }
      if (this.cadastro.dados_cadastrais.pessoa === "FISICA") {
        if (
          this.cadastro.dados_cadastrais.nome.length < 2 ||
          this.cadastro.dados_cadastrais.nome === ""
        ) {
          this.$config.alert(
            i18n.t("customers.name-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.nome = i18n.t(
            "customers.name-error"
          );
          return;
        }
      }

      if (this.cadastro.dados_cadastrais.pessoa === "FISICA") {
        if (
          this.cadastro.dados_cadastrais.dt_nascimento.length < 2 ||
          this.cadastro.dados_cadastrais.dt_nascimento === ""
        ) {
          this.$config.alert(
            i18n.t("customers.birth-date-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.dt_nascimento = i18n.t(
            "customers.birth-date-error"
          );
          return;
        }
      }

      if (this.cadastro.dados_cadastrais.pessoa == "FISICA") {
        if (this.cadastro.dados_cadastrais.pais === "Brasil") {
          if (
            (this.cadastro.dados_cadastrais.documento &&
              this.cadastro.dados_cadastrais.documento.length < 13) ||
            this.cadastro.dados_cadastrais.documento === ""
          ) {
            this.$config.alert(
              i18n.t("customers.document-error"),
              this.$config.dados.errorColor
            );
            this.cadastro.dados_cadastrais.error.documento = i18n.t(
              "customers.document-error"
            );
            return;
          }
        } else {
          if (
            (this.cadastro.dados_cadastrais.passaporte &&
              this.cadastro.dados_cadastrais.passaporte.length < 8) ||
            this.cadastro.dados_cadastrais.passaporte === ""
          ) {
            this.$config.alert(
              i18n.t("customers.passport-error"),
              this.$config.dados.errorColor
            );
            this.cadastro.dados_cadastrais.error.passaporte = i18n.t(
              "customers.passport-error"
            );
            return;
          }
        }
      }

      // }

      if (this.cadastro.dados_cadastrais.pessoa === "JURIDICA") {
        if (
          (this.cadastro.dados_cadastrais.cnpj &&
            this.cadastro.dados_cadastrais.cnpj.length < 17) ||
          this.cadastro.dados_cadastrais.cnpj === ""
        ) {
          this.$config.alert(
            i18n.t("customers.cnpj-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.cnpj = i18n.t(
            "customers.cnpj-error"
          );
          return;
        }

        if (!this.$config.validarCNPJ(this.cadastro.dados_cadastrais.cnpj)) {
          this.$config.alert(
            i18n.t("customers.invalid-cnpj-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.cnpj = i18n.t(
            "customers.invalid-cnpj-error"
          );
          return;
        }

        if (
          (this.cadastro.dados_cadastrais.razao_social &&
            this.cadastro.dados_cadastrais.razao_social.length < 5) ||
          this.cadastro.dados_cadastrais.razao_social === ""
        ) {
          this.$config.alert(
            i18n.t("customers.social-reason-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.razao_social = i18n.t(
            "customers.social-reason-error"
          );
          return;
        }
      }

      if (
        (this.cadastro.dados_cadastrais.email &&
          this.cadastro.dados_cadastrais.email.length < 5) ||
        this.cadastro.dados_cadastrais.email === ""
      ) {
        this.$config.alert(
          i18n.t("customers.email-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.email = i18n.t(
          "customers.email-error"
        );
        return;
      }

      if (!this.$config.validarEmail(this.cadastro.dados_cadastrais.email)) {
        this.$config.alert(
          i18n.t("customers.invalid-email-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.email = i18n.t(
          "customers.invalid-email-error"
        );
        return;
      }

      if (
        (this.cadastro.dados_cadastrais.celular &&
          this.cadastro.dados_cadastrais.celular.length < 10) ||
        this.cadastro.dados_cadastrais.celular === ""
      ) {
        this.$config.alert(
          i18n.t("customers.phone-number-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.celular = i18n.t(
          "customers.phone-number-error"
        );
        return;
      }

      if (this.cadastro.dados_cadastrais.status === "") {
        this.$config.alert(
          i18n.t("customers.status-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.status = i18n.t(
          "customers.status-error"
        );
        return;
      }

      if (
        this.cadastro.dados_cadastrais.cep.length < 8 ||
        this.cadastro.dados_cadastrais.cep === ""
      ) {
        this.$config.alert(
          i18n.t("customers.cep-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.cep = i18n.t(
          "customers.cep-error"
        );
        return;
      }

      if (this.cadastro.dados_cadastrais.estado === "") {
        this.$config.alert(
          i18n.t("customers.state-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.estado = i18n.t(
          "customers.state-error"
        );
        return;
      }

      if (this.cadastro.dados_cadastrais.cidade === "") {
        this.$config.alert(
          i18n.t("customers.city-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.cidade = i18n.t(
          "customers.city-error"
        );
        return;
      }

      if (this.cadastro.dados_cadastrais.bairro === "") {
        this.$config.alert(
          i18n.t("customers.district-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.bairro = i18n.t(
          "customers.district-error"
        );
        return;
      }

      if (this.cadastro.dados_cadastrais.logradouro === "") {
        this.$config.alert(
          i18n.t("customers.street-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.logradouro = i18n.t(
          "customers.street-error"
        );
        return;
      }

      if (this.cadastro.dados_cadastrais.end_numero === "") {
        this.$config.alert(
          i18n.t("customers.number-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.end_numero = i18n.t(
          "customers.number-error"
        );
        return;
      }

      if (this.consumidorAddOrEdit == "editar") {
        this.alterarConsumidor();
      } else {
        this.cadastrarConsumidor();
      }
    },

    limpaFormularioDeConsumidor() {
      this.cadastro.dados_cadastrais.pessoa = "FISICA";
      this.cadastro.dados_cadastrais.nome = "";
      this.cadastro.dados_cadastrais.dt_nascimento = "";
      this.cadastro.dados_cadastrais.documento = "";
      this.cadastro.dados_cadastrais.passaporte = "";
      this.cadastro.dados_cadastrais.email = "";
      this.cadastro.dados_cadastrais.celular = "";
      this.cadastro.dados_cadastrais.idioma = "";
      this.cadastro.dados_cadastrais.status = "";
      this.cadastro.dados_cadastrais.foto.imagem = null;
      this.cadastro.dados_cadastrais.foto.have = false;
      this.cadastro.dados_cadastrais.permite_pacote = false;
      delete this.cadastro.dados_cadastrais.foto.object;
      this.cadastro.dados_cadastrais.error.nome = [];
      this.cadastro.dados_cadastrais.error.email = [];
      this.cadastro.dados_cadastrais.error.celular = [];
      this.cadastro.dados_cadastrais.error.status = [];
      this.cadastro.dados_cadastrais.error.dt_nascimento = [];
      this.cadastro.dados_cadastrais.error.documento = [];
      this.cadastro.dados_cadastrais.error.passaporte = [];

      this.cadastro.dados_cadastrais.bairro = "";
      this.cadastro.dados_cadastrais.logradouro = "";
      this.cadastro.dados_cadastrais.end_numero = "";
      this.cadastro.dados_cadastrais.cep = "";
      this.cadastro.dados_cadastrais.pais = "";
      this.cadastro.dados_cadastrais.estado = "";
      this.cadastro.dados_cadastrais.cidade = "";
      this.cadastro.dados_cadastrais.error.bairro = [];
      this.cadastro.dados_cadastrais.error.logradouro = [];
      this.cadastro.dados_cadastrais.error.end_numero = [];
      this.cadastro.dados_cadastrais.error.cep = [];
      this.cadastro.dados_cadastrais.error.pais = [];
      this.cadastro.dados_cadastrais.error.estado = [];
      this.cadastro.dados_cadastrais.error.cidade = [];

      this.cadastro.dados_cadastrais.cnpj = "";
      this.cadastro.dados_cadastrais.razao_social = "";
      this.cadastro.dados_cadastrais.error.cnpj = [];
      this.cadastro.dados_cadastrais.error.razao_social = [];
    },

    limpaFiltros() {
      this.filter.nome = "";
      this.filter.razao_social = "";
      this.filter.documento = "";
      this.filter.passaporte = "";
      this.filter.cnpj = "";
      this.filter.permite_pacote = false;
      this.filter.status = "";
      this.filter.tipoPessoa = "";
      this.filter.dataInicio = "";
      this.filter.dataFim = "";
      this.filter.estado = "";
      this.filter.cidade = "";
      this.filter.email = "";
      this.filter.sequenciador = null;
      this.filter.event = "";
      this.filtros = [];
    },
  },
});
